import { TOOLTIP } from "../../constant";
const ThumbDown = (props) => {
  const { disliked, onClick } = props;
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      role="img" 
      aria-label="Thumb Down"
    >
      <path
        d="M13.3769 2.83417V2.8345V9.3505C13.3769 10.2376 13.0891 11.1008 12.5569 11.8105L10.8769 14.0496L10.8769 14.0497C10.1628 15.0017 9.77686 16.1597 9.77686 17.3497V18.1501C9.77686 18.2827 9.72418 18.4099 9.63041 18.5037C9.53664 18.5974 9.40946 18.6501 9.27686 18.6501C8.82599 18.6501 8.39359 18.471 8.07477 18.1522C7.75596 17.8334 7.57686 17.401 7.57686 16.9501V12.1501V11.4501H6.87686H2.60493C2.6049 11.4501 2.60488 11.4501 2.60486 11.4501C2.3534 11.4501 2.10507 11.3942 1.87779 11.2867C1.65048 11.1791 1.44987 11.0224 1.29043 10.8279C1.13099 10.6334 1.01669 10.406 0.955755 10.162C0.894831 9.91801 0.88879 9.66356 0.938065 9.41698C0.93807 9.41695 0.938074 9.41693 0.93808 9.4169L2.37807 2.21698L2.37808 2.2169C2.45514 1.83138 2.66343 1.48448 2.96751 1.23527C3.27158 0.986057 3.65263 0.849943 4.04578 0.8501H4.04606H10.545C10.5451 0.8501 10.5452 0.8501 10.5453 0.8501C11.181 0.850336 11.808 0.998419 12.3767 1.28265L12.4366 1.3126L12.4368 1.31267C12.7194 1.45389 12.957 1.67105 13.1231 1.9398C13.2891 2.20855 13.377 2.51826 13.3769 2.83417ZM19.2769 10.0501H17.2769C16.5589 10.0501 15.9769 9.46807 15.9769 8.7501V2.5001C15.9769 1.78213 16.5589 1.2001 17.2769 1.2001H19.2769C19.9948 1.2001 20.5769 1.78213 20.5769 2.5001V8.7501C20.5769 9.46807 19.9948 10.0501 19.2769 10.0501Z"
        stroke={disliked ? "#aa001b" : "#576579"}
        fill={disliked ? "#aa001b" : ""}
        strokeWidth="1.4"
      />
      <title>{ TOOLTIP.DISLIKE }</title>
    </svg>
  );
};

export default ThumbDown;
